import {
  Application,
  CreateApplicationDTO,
  PaginatedApplicationsResponse,
  UpdateApplicationDTO,
} from "@/contracts/auth-api.types";
import { apiRequest } from "./apiClient";

export const applicationService = {
  /**
   * Lista todas as aplicações cadastradas no ecossistema (Master App admin only).
   */
  async list(page = 1, limit = 20): Promise<PaginatedApplicationsResponse | Application[]> {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });
    return await apiRequest<PaginatedApplicationsResponse | Application[]>(
      `/applications?${params.toString()}`,
    );
  },

  /**
   * Obtém detalhes de uma aplicação específica por ID.
   */
  async getById(id: string): Promise<Application> {
    return await apiRequest<Application>(`/applications/${id}`);
  },

  /**
   * Cria uma nova aplicação / tenant MVP (Master App admin only).
   */
  async create(dto: CreateApplicationDTO): Promise<Application> {
    return await apiRequest<Application>("/applications", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dto),
    });
  },

  /**
   * Atualiza configurações de uma aplicação existente.
   */
  async update(id: string, dto: UpdateApplicationDTO): Promise<Application> {
    return await apiRequest<Application>(`/applications/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dto),
    });
  },

  /**
   * Remove uma aplicação e seus recursos em cascata.
   */
  async delete(id: string): Promise<void> {
    await apiRequest<void>(`/applications/${id}`, {
      method: "DELETE",
    });
  },
};
